import { LOGOUT, SET_CURRENT_REQUEST, SET_REQUESTS_LIST, UPDATE_REQUEST_CANCELED, UPDATE_REQUEST_ATTACHMENT, UPDATE_REQUEST_CONFIRMATIONS } from "../actions/types";

const INITIAL_STATE = {
    current: {
        requestID: null,
        userID: null,
        absenceID: null,
        absenceName: null,
        occasionID: null,
        occasionName: null,
        dateFrom: null,
        timeFrom: null,
        dateTo: null,
        timeTo: null,
        forMonth: null,
        submitedOn: null,
        attachment: null,
        attachmentRequired: null,
        canceled: null,
        canceledOn: null,
        accepted: null,
        entered: null,
        enteredOn: null,
        confirmations: [],
        fname: null,
        lname: null,
        email: null,
        ouID: null,
        ouName: null,
        actionAllowed: null,
        hrActionAllowed: null
    },
    list: [],
    pages: null
};

const requestReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CURRENT_REQUEST:
            return {
                ...state,
                current: {
                    requestID: action.payload.requestID,
                    userID: action.payload.userID,
                    absenceID: action.payload.absenceID,
                    absenceName: action.payload.absenceName,
                    occasionID: action.payload.occasionID,
                    occasionName: action.payload.occasionName,
                    dateFrom: action.payload.dateFrom,
                    timeFrom: action.payload.timeFrom,
                    dateTo: action.payload.dateTo,
                    timeTo: action.payload.timeTo,
                    forMonth: action.payload.forMonth,
                    submitedOn: action.payload.submitedOn,
                    attachment: action.payload.attachment,
                    attachmentRequired: action.payload.attachmentRequired,
                    canceled: action.payload.canceled,
                    canceledOn: action.payload.canceledOn,
                    accepted: action.payload.accepted,
                    entered: action.payload.entered,
                    enteredOn: action.payload.enteredOn,
                    confirmations: action.payload.confirmations.map(confirmation => {
                        return {
                            ouID: confirmation.ouID,
                            ouName: confirmation.ouName,
                            required: confirmation.required,
                            accepted: confirmation.accepted,
                            acceptedOn: confirmation.acceptedOn,
                            fname: confirmation.fname,
                            lname: confirmation.lname
                        };
                    }),
                    fname: action.payload.fname,
                    lname: action.payload.lname,
                    email: action.payload.email,
                    ouID: action.payload.ouID,
                    ouName: action.payload.ouName,
                    actionAllowed: action.payload.actionAllowed,
                    hrActionAllowed: action.payload.hrActionAllowed
                }
            };
        case SET_REQUESTS_LIST:
            return {
                ...state,
                list: action.payload.requests.map(request => {
                    return {
                        requestID: request.requestID,
                        userID: request.userID,
                        absenceID: request.absenceID,
                        absenceName: request.absenceName,
                        occasionID: request.occasionID,
                        occasionName: request.occasionName,
                        dateFrom: request.dateFrom,
                        timeFrom: request.timeFrom,
                        dateTo: request.dateTo,
                        timeTo: request.timeTo,
                        forMonth: request.forMonth,
                        submitedOn: request.submitedOn,
                        attachment: request.attachment,
                        attachmentRequired: request.attachmentRequired,
                        canceled: request.canceled,
                        canceledOn: request.canceledOn,
                        accepted: request.accepted,
                        entered: request.entered,
                        enteredOn: request.enteredOn,
                        fname: request.fname,
                        lname: request.lname,
                        email: request.email,
                        ouID: request.ouID,
                        ouName: request.ouName
                    };
                }),
                pages: action.payload.pages
            };
        case UPDATE_REQUEST_CANCELED:
            return {
                ...state,
                current: {
                    ...state.current,
                    canceled: action.payload.canceled,
                    canceledOn: action.payload.canceledOn
                }
            };
        case UPDATE_REQUEST_ATTACHMENT:
            return {
                ...state,
                current: {
                    ...state.current,
                    attachment: action.payload.attachment
                }
            };
        case UPDATE_REQUEST_CONFIRMATIONS:
            return {
                ...state,
                current: {
                    ...state.current,
                    accepted: (action.payload.accepted === null || action.payload.accepted === undefined) ? state.current.accepted : action.payload.accepted,
                    confirmations: (action.payload.confirmations === null || action.payload.confirmations === undefined) ? state.current.confirmations : action.payload.confirmations.map(confirmation => {
                        return {
                            ouID: confirmation.ouID,
                            ouName: confirmation.ouName,
                            accepted: confirmation.accepted,
                            acceptedOn: confirmation.acceptedOn,
                            fname: confirmation.fname,
                            lname: confirmation.lname
                        };
                    }),
                    entered: (action.payload.entered === null || action.payload.entered === undefined) ? state.current.entered : action.payload.entered,
                    enteredOn: (action.payload.enteredOn === null || action.payload.enteredOn === undefined) ? state.current.enteredOn : action.payload.enteredOn
                }
            }
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default requestReducer;